import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from '@mui/material';
import { useTranslation } from 'react-i18next';

import { WorkflowProposalProcess } from '~/components/WorkflowProposalProcess';
import { EmploymentPositionProposalProps } from '~/data/proposals';
import { useEmployeeProposal } from '~/features/ScheduledEmploymentChanges/ScheduleChanges/components/ScheduleEmployment/data/useEmployeeProposal';
import { EmployeeProposalDecision } from '~/scenes/RewardingModule/components/EmployeeProposalsDialog/components/EmployeeProposal/components/Forms/Common';

export const OngoingEmpPositionProposalDialog = ({
  proposal,
  open,
  onClose,
  onSubmit,
}: {
  proposal: EmploymentPositionProposalProps;
  open: boolean;
  onClose: () => void;
  onSubmit: (
    proposal: EmploymentPositionProposalProps,
    decision?: EmployeeProposalDecision,
  ) => void;
}) => {
  const { handleDecision, handleUltimateDecision } = useEmployeeProposal({
    proposal,
    onSubmit,
  });
  const { t } = useTranslation();
  return (
    <Dialog open={open} onClose={onClose} sx={{ p: 3 }}>
      <DialogTitle>{t('laEMP_POSITION_PROPOSAL')}</DialogTitle>
      <DialogContent>
        <WorkflowProposalProcess
          proposal={proposal}
          onDecision={(decision) => {
            handleDecision(decision);
            onClose();
          }}
          onUltimateDecision={(decision) => {
            handleUltimateDecision(decision);
            onClose();
          }}
        />
      </DialogContent>
      <DialogActions>
        <Button
          onClick={onClose}
          data-testid="emp-position-proposal-dialog-close-button"
        >
          {t('close')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
